<mat-dialog-content>
    <div class="details-card-container" *ngIf="audit">
        <mat-card class="details-card">
            <mat-card-header>
                <mat-card-title class="mat-card-header-text">Audit details</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="properties">
                    <b>Date:</b>
                    <div class="important">{{ audit.date | date: 'dd/MM/yyyy à HH:mm:ss' }}</div>
                </div>
                <div class="properties">
                    <b>Entity:</b>
                    <div class="important">{{ audit.model }}</div>
                </div>
                <div class="properties">
                    <b>Primary Keys:</b>
                    <ul>
                        <li *ngFor="let entry of audit.primaryKeys | keys">
                            <b>{{ entry.key }}</b> <span>{{ entry.value }}</span>
                        </li>
                    </ul>
                </div>
                <div class="properties">
                    <b>Changed Properties:</b>
                    <ul>
                        <li *ngFor="let entry of audit.changedProperties | keys">
                            <b>{{ entry.key }}</b>
                            <span [ngSwitch]="type(entry.value)">
                                <ul *ngSwitchCase="'object'">
                                    <li *ngFor="let property of entry.value | keys">
                                        <b>{{ property.key }}</b> <span>{{ property.value }}</span>
                                    </li>
                                </ul>
                                <span *ngSwitchDefault>{{ entry.value }}</span>
                            </span>
                        </li>
                    </ul>
                </div>
                <div class="properties">
                    <b>Custom Properties:</b>
                    <ul>
                        <li *ngFor="let entry of audit.customProperties | keys">
                            <b>{{ entry.key }}</b>
                            <span>{{ entry.value }}</span>
                        </li>
                    </ul>
                </div>
            </mat-card-content>
            <mat-card-footer class="footer">
                <div><b>ID:</b> {{ audit._id }}</div>
            </mat-card-footer>
        </mat-card>
    </div>
</mat-dialog-content>